export default __webpack_public_path__ + "static/media/tw-white.fe500bd1.svg";